export const GET_PROJECTS = 'PROJECT/GET_ALL';
export const GET_PROJECTS_SUCCESS = 'PROJECT/GET_ALL_SUCCESS';

export const GET_NOTIFICATIONS = 'USER/GET_NOTIFICATIONS';

export const GET_TODO = 'USER/GET_TODO';
export const GET_TODO_SUCCESS = 'USER/GET_TODO_SUCCESS';
export const CREATE_TODO = 'USER/CREATE_TODO';
export const CREATE_TODO_SUCCESS = 'USER/CREATE_TODO_SUCCESS';
export const UPDATE_TODO = 'USER/UPDATE_TODO';
export const DELETE_TODO = 'USER/DELETE_TODO';

export const GET_NOTES = 'USER/GET_NOTES';
export const GET_NOTES_SUCCESS = 'USER/GET_NOTES_SUCCESS';
export const CREATE_NOTE = 'USER/CREATE_NOTE';
export const CREATE_NOTE_SUCCESS = 'USER/CREATE_NOTE_SUCCESS';
export const UPDATE_NOTE = 'USER/UPDATE_NOTES';
export const DELETE_NOTE = 'USER/DELETE_NOTE';

export const GET_INVITATIONS = 'USER/GET_INVITATIONS';
export const GET_INVITATIONS_SUCCESS = 'USER/GET_INVITATIONS_SUCCESS';

export const CREATE_PROJECT = 'USER/CREATE_PROJECT';
export const CREATE_PROJECT_SUCCESS = 'USER/CREATE_PROJECT_SUCCESS';

export const ARCHIVE_PROJECT = 'USER/ARCHIVE_PROJECT';
export const UNARCHIVE_PROJECT = 'USER/UNARCHIVE_PROJECT';
export const DELETE_PROJECT = 'USER/DELETE_PROJECT';

export const UPDATE_INVITATION = 'USER/UPDATE_INVITATION';

export const SET_NOTIFICATIONS_SEEN = 'USER/GET_NOTIFICATIONS';

export const CREATE_NOTIFICATION = 'USER/CREATE_NOTIFICATION';

export const TASK_BY_DATE = 'TASK_BY_DATE';
